// StatusChip (Spec §7) — one consistent status vocabulary + colour map, used
// everywhere a status is shown so the same tone always means the same thing.

import type { ReactNode } from 'react'

export type StatusTone = 'neutral' | 'info' | 'success' | 'warning' | 'danger' | 'active'

const TONES: Record<StatusTone, string> = {
  neutral: 'bg-slate-100 text-slate-700 border-slate-200',
  info: 'bg-iflow-50 text-iflow-700 border-iflow-200',
  success: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  warning: 'bg-amber-50 text-amber-800 border-amber-200',
  danger: 'bg-rose-50 text-rose-700 border-rose-200',
  active: 'bg-iflow-100 text-iflow-800 border-iflow-300',
}

interface StatusChipProps {
  children: ReactNode
  tone?: StatusTone
  icon?: ReactNode
  className?: string
}

export default function StatusChip({ children, tone = 'neutral', icon, className = '' }: StatusChipProps) {
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border px-2.5 py-0.5 text-xs font-medium ${TONES[tone]} ${className}`}
    >
      {icon && <span className="shrink-0" aria-hidden>{icon}</span>}
      {children}
    </span>
  )
}
